import { render } from "./Nasaha.vue?vue&type=template&id=7f344b1b&scoped=true"
import script from "./Nasaha.vue?vue&type=script&lang=js"
export * from "./Nasaha.vue?vue&type=script&lang=js"

import "./Nasaha.vue?vue&type=style&index=0&id=7f344b1b&scoped=true&lang=css"

import exportComponent from "/pro/vue/Attamayyuz_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f344b1b"]])

export default __exports__